Vue.component("form-select", {
    props: ['list', 'selected', 'placeholder', 'customclass', 'showother'],
    data: function () {
        return {
            isOpen: false,
            otherSelected: false
        };
    },
    mounted: function () {
        var _this = this;
        //console.log($(_this)[0].$refs.elem);
        //new SimpleBar($(_this)[0].$refs.elem);
        $(document).mouseup(function (e) {
            _this.processDropdownClick(false, e);
        });
    },
    methods: {
        getPhrase: function (phrase) {
            return this.$options.filters.phrase(phrase);
        },
        processDropdownClick: function (forceState, event) {
            event.preventDefault();
            var $elem = $(this.$refs.elem);

            if ($('.dropdown-results :visible').length > 0) {
                forceState = false;
            }
            this.isOpen = forceState != null ? !!forceState : !this.isOpen;
            var $listElem = $(this.$refs.list);
            var animationSpeed = 200;

            if (this.isOpen) {
                $listElem.stop().slideDown(animationSpeed);
                $elem.addClass('open');
            } else {
                $listElem.stop().slideUp(animationSpeed);
                $elem.removeClass('open');
            }
        },
        selectItem: function (item, event, selectOther) {
            this.selected = item;
            this.otherSelected = selectOther;
            this.$emit('update:selected', this.selected);
            this.processDropdownClick(true, event);
        },
        getTitle: function () {
            var _this = this;
            return !!_this.selected && !!_this.selected['id'] ? (_this.selected['icon'] ? '<i>' + _this.selected['icon'] + '</i>' + _this.selected['title'] : _this.selected['title']) : (_this.otherSelected ? 'სხვა' : _this.placeholder);
        }
    },
    template: '<div class=\"dropdown\"\
                 ref="elem"\
                v-bind:class=\"customclass\"\
                 v-on:click=\"processDropdownClick(null, $event)\">\
                <a href=\"\" class=\"dropdown-trigger\">\
                    <span v-html=\"getTitle()\"></span>\
                    <svg class=\"dropdown-icon\">\
                        <use xlink:href=\"~/m/i/icons.svg#symbol-caretdropdown\"></use>\
                    </svg>\
                </a>\
                <div class=\"dropdown-results\" data-simplebar ref=\"list\">\
                    <div>\
                        <a href=\"\" class=\"dropdown-results-item\"  v-for=\"item in list\"  v-on:click=\"selectItem(item, $event, false)\"><i v-show=\"item[\'icon\']\" v-html=\"item[\'icon\']\"></i>{{item[\'title\']}}</a>\
                        <a href=\"\" class=\"dropdown-results-item\"  v-if=\"showother\" v-on:click=\"selectItem(true, $event, true)">სხვა</a>\
                    </div>\
                </div>\
            </div>\
'
});
 //v-bind:class="{'dropdown--currency' : selected && customclass}"

